<script>
  import { onMount } from 'svelte'
  import { scrollToY } from '../../services/utilities.js'
  import { user } from '../../models/user.js'

  let reviews = [
    {
      comment:
        'I liked this one. Nice size & shape of pieces. Very vibrant colors and enjoyable to do.',
      who: 'Ellen F',
      puzzle_title: 'Bird Houses',
      puzzle_brand: 'Jacarou',
      link: 'https://puzzleexchange.com/product/Bird-Houses/sku/JAVA-7551-R',
    },
    {
      comment: 'So Cute. Love the Disney Ravensburger puzzles! Thank You!',
      who: 'Hanna D',
      puzzle_title: 'Dumbo',
      puzzle_brand: 'Ravensburger',
      link: 'https://puzzleexchange.com/product/Dumbo/sku/RAVE-6760-R',
    },
    {
      comment:
        'This is the most carefully considered & well presented puzzle service I have ever seen. Thank you SO much for being so thoughtful & thorough. It makes the puzzles that much more enjoyable.',
      who: 'Haven H',
    },
    {
      comment:
        'My favorite yet! Challenging but when you picked up a piece you knew you had the right one! Loved it!',
      who: 'Kevyn F',
      puzzle_title: 'Midnight Garden',
      puzzle_brand: 'Lemonade Pursuits',
      link:
        'https://puzzleexchange.com/product/Midnight-Garden/sku/LEMO-4430-R',
    },
    {
      comment:
        'I really like how you are marking the puzzles I have already checked out on your site. Thanks, I Love Your "Missing Piece" company.',
      who: 'Carol H',
    },
    {
      comment:
        'So much fun – loved this one – perfect for a dreary rainy spring!',
      who: 'Hanna D',
      puzzle_title: 'Dampy Donuts on a Dreary Day',
      puzzle_brand: 'Buffalo',
      link:
        'https://puzzleexchange.com/product/Dampy-Donuts-on-a-Dreary-Day/sku/BUFF-1457-R',
    },
    {
      comment:
        'I love this bonus when using your puzzles. No Puzzle Dust!! I received a puzzle pack from my daughter for my January birthday. Perfect timing and hours of enjoyment. No waste of purchasing puzzles. I love using your business and have been sharing it with others.',
      who: 'Laurie O',
    },
    {
      comment:
        'I have never done a special shape puzzle before so this was definitely very challenging!',
      who: 'Erika',
      puzzle_title: 'Stained Glass Butterfly',
      puzzle_brand: 'Sunsout',
    },
    {
      comment:
        'Thank You! It was my first order and I loved it! I am waiting for my new puzzles to arrive! I love the flexibility you offer!',
      who: 'Daphne',
      puzzle_title: '',
    },
    {
      comment:
        'I love Missing Piece! The puzzle collection is huge including amazing original puzzles. I looked at other puzzle exchange subscriptions but chose this one because it lets me choose the puzzles AND get multiple at once. Erin even responded to my puzzle feedback in my next shipment.',
      who: 'Westley',
      puzzle_title: '',
    },
    {
      comment: 'Hidden words/phrases made this interesting',
      who: 'Mallary',
      puzzle_title: 'That’s the Point',
      puzzle_brand: 'Art & Fable',
      link: "https://puzzleexchange.com/product/That's-the-Point/sku/AF-3409-1",
    },
    {
      comment:
        'If you’re an avid jigsaw puzzler like I am, do not hesitate to join Missing Piece Puzzle Exchange. For an amount less than 2 store bought puzzles, you can rent 3-4 puzzles A MONTH and there are hundreds of puzzles to choose from. Plus the customer service is great!',
      who: 'Chevic',
      puzzle_title: '',
      puzzle_brand: '',
    },
    {
      comment: 'One of the most fun puzzles I’ve ever done',
      who: 'Siobhan',
      puzzle_title: 'Great Wave of Kanagawa',
      puzzle_brand: 'Eurographics',
      link:
        'https://puzzleexchange.com/product/Great%20Wave%20of%20Kanagawa/sku/EURO-1545',
    },
    {
      comment:
        'This one is gorgeous and gives you a sense of accomplishment when done',
      who: 'Cheryl',
      puzzle_title: 'Rocky Mountain National Park',
      puzzle_brand: 'Eurographics',
      link:
        'https://puzzleexchange.com/product/Rocky-Mountain-National-Park/sku/EUGR-65472',
    },
  ]

  let headerImgs = [
    {
      text: 'Rent',
      image: 'https://images.puzzleexchange.com/home/rent-11-2024-lg.jpg',
      url: '/rent',
      imgText:
        'Rent. Here at the Missing Piece Puzzle Exchange, choose puzzles to rent with a puzzle subscription. Casual puzzler or avid puzzler, we have a plan for you! Check out our one time rentals with Puzzle Packs or get a recurring monthly puzzle subscription box.',
    },
    {
      text: 'Puzzle',
      image: 'https://images.puzzleexchange.com/home/puzzle-11-2024-lg.jpg',
      url: '/rent',
      imgText:
        'Puzzle. Hundreds of jigsaw puzzle rentals to choose from. We even have jigsaw puzzle accessories! Check out our puzzle covers and puzzle glue sheets.',
    },
    {
      text: 'Return',
      image: 'https://images.puzzleexchange.com/home/return-2022-lg.jpg',
      url: '/how-it-works',
      imgText:
        'Return. With our puzzle pack and our avid monthly puzzle subscription box, you can select your next shipment prior to returning to make sure you always have puzzles in your house!',
    },
    {
      text: 'Repeat',
      image: 'https://images.puzzleexchange.com/home/repeat-11-2024-lg.jpg',
      url: '/rent',
      imgText:
        'Repeat. Make sure to sign up for our Puzzle Exchange subscription box to never be without a jigsaw puzzle.',
    },
  ]

  onMount(async () => {
    document.title =
      'Jigsaw Puzzle Rentals & Subscriptions | Missing Piece Puzzle Exchange'

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Missing Piece Puzzle Exchange',
      url: 'https://www.puzzleexchange.com',
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: String(reviews.length),
      },
      review: reviews
        .filter((r) => r.comment && r.who !== 'Customer')
        .slice(0, 10)
        .map((r) => ({
          '@type': 'Review',
          author: { '@type': 'Person', name: r.who },
          reviewBody: r.comment,
          reviewRating: { '@type': 'Rating', ratingValue: '5' },
        })),
    }
    const el = document.createElement('script')
    el.type = 'application/ld+json'
    el.textContent = JSON.stringify(schema)
    document.head.appendChild(el)

    let popUpShown = document.cookie
      .split('; ')
      .find((c) => c.indexOf('mailerlite:webform:shown:3736759') >= 0)

    if (!popUpShown) {
      let ml_webform_3736759 = ml_account(
        'webforms',
        '3736759',
        'h7b2m3',
        'load',
      )
      ml_webform_3736759('animation', 'fadeIn')

      if (!$user || !$user.username) {
        ml_webform_3736759('show')
      }
    }

    scrollToY(0)
  })

  let formatURL = (img, sz) => {
    if (sz) return `${img.url}${img.filename}-${sz}.${img.extension}`
    else return `${img.url}${img.filename}.${img.extension}`
  }
</script>

<style type="text/less">
  .review-cont {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin: auto;
    width: 50%;
  }

  .review {
    display: flex;
    flex-direction: column;
    padding: 2rem;

    .icon {
      color: var(--col-accent-2);
      width: 27px;
      height: 27px;
    }

    .pp-icon {
      height: 24px;
      width: 30px;
    }
  }

  .comment {
    color: var(--col-gray-40);
  }

  section {
    max-width: var(--content-width);
    margin: auto;
  }

  .image-fill {
    height: 50vh;
  }

  .header-imgs {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: var(--spacing-xs);
  }

  .header-img-cont {
    position: relative;
    text-align: center;
    color: white;
    font-size: 3rem;
    letter-spacing: 2px;
    line-height: 1.5;
  }

  .header-imgs img {
    height: 250px;
    width: 100%;
    object-fit: cover;
  }

  .header-img-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: var(--col-accent-2);
    width: 100%;
  }

  .getting-started {
    margin: 2rem auto;
    h1 {
      line-height: calc(var(--line-height) * 1.5);
    }

    .brand-name {
      font-size: 0.55em;
      font-weight: normal;
      color: var(--col-accent-2-l);
      letter-spacing: 0.05em;
      text-transform: uppercase;
    }

    p {
      padding: 1rem;
    }
  }

  .how-it-works {
    margin-top: var(--spacing-sm);
  }

  .img-url {
    color: white;
    text-decoration: none;
  }

  @media (max-width: 950px) {
    .review-cont {
      width: 100%;
      grid-template-columns: 1fr;
    }

    .image-fill {
      height: 30vh;
    }

    .header-imgs {
      img {
        height: 150px;
      }
      .header-img-cont {
        font-size: 2rem;
      }
      grid-template-columns: repeat(2, 1fr);
    }

  }
</style>

<main>
  <section class="header-imgs">
    {#each headerImgs as img, i}
      <div class="header-img-cont">
        <a class="img-url" href={img.url}>
          <img
            alt={img.imgText}
            src={img.image}
            loading="eager"
            fetchpriority={i === 0 ? 'high' : 'auto'} />
          <div class="header-img-text">{img.text}</div>
        </a>
      </div>
    {/each}
  </section>

  <section class="text-center">
    <div class="getting-started">
      <h1>
        Jigsaw Puzzle Rentals &amp; Subscriptions
        <br />
        <span class="brand-name">Missing Piece Puzzle Exchange</span>
      </h1>
      <p>
        Save money and do more puzzles by signing up for a puzzle rental
        subscription.
      </p>
      <div>
        <a href="ways-to-rent">
          <button class="btn">Rental Options</button>
        </a>
        <a href="shop">
          <button class="btn">Shop our Collection</button>
        </a>
      </div>
      <div class="how-it-works">
        <a href="how-it-works">Curious how it works? Learn more.</a>
      </div>
    </div>
  </section>

  <section>
    <h2 class="text-center">Testimonials</h2>
    <div class="review-cont" tabindex="0">
      {#each reviews as r}
        <div class="card review">
          <div class="icon-text">
            <svg class="icon">
              <use href="/icons.svg#person" />
            </svg>
            <span>{r.who}</span>
          </div>
          <div class="icon-text">
            {#if r.puzzle_brand && r.puzzle_title}
              <svg class="icon pp-icon">
                <use href="/icons.svg#puzzle-piece" />
              </svg>
              {#if r.link}
                <a href={r.link} target="_blank" rel="noreferrer">
                  <span>{r.puzzle_brand} - {r.puzzle_title}</span>
                </a>
              {:else}
                <span>{r.puzzle_brand} - {r.puzzle_title}</span>
              {/if}
            {/if}
          </div>
          <br />
          <span class="comment">"{r.comment}"</span>
        </div>
      {/each}
    </div>
  </section>
</main>
